/*
 *
 * Do not edit directly
 * Generated on Wed, 16 Jul 2025 15:14:59 GMT
 *
 */


const theme = {
  appearances: {
    dots: { type: 'variant', values: [ true ] },
    size: {
      description: 'used for full-screen spinners',
      type: 'variant',
      values: [ 'large', 'small' ]
    },
    style: { type: 'variant', values: [ 'dots' ] }
  },
  rules: [
    {
      if: { size: 'large' },
      tokens: { dotSize: 12, size: 48, thickness: 4 }
    },
    {
      if: { size: 'small' },
      tokens: { dotSize: 6, size: 24, thickness: 3 }
    }
  ],
  tokens: {
    color: '#ff0076',
    dotSize: 12,
    fullScreenOverlayBackground: 'rgba(255, 255, 255, 0.8)',
    indicatorBackgroundColor: '#ffd1e6',
    size: 48,
    thickness: 4
  }
}
export default theme
